export default __webpack_public_path__ + "1.17.19/static/media/LibreDataShare_Japanese.504fe043.svg";